var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-call-container"},[_c('video',{ref:"localVideo",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}}),_c('video',{ref:"remoteVideo",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }